import { CardContent, styled } from '@mui/material';

export const FormCardContent = styled(CardContent)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
}));
